import { RESET_STATE } from 'store/global/actions';

import { TRUST_ACTION_TYPE } from '../actions';

const initialState = {};

const trustReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TRUST_ACTION_TYPE.GET_TRUST_INFO:
    case TRUST_ACTION_TYPE.EDIT_TRUST_INFO:
    case TRUST_ACTION_TYPE.DELETE_TRUST_INFO:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default trustReducer;
